import React, { useState } from "react";
import CustomSelect from "../../../components/main_comps/custom_select";
import { CLIENT, RESELLER } from "../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import { useSelector } from "react-redux";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import moment from "moment";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { saveAs } from "file-saver";

const DownloadReportCustomer = ({ onChange, selectedServiceProvider }) => {
  const location = useLocation();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedReseller, setSelectedReseller] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [van, setVan] = useState("");
  const [selectedServiceProviderName, setSelectedServiceProviderName] =
    useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [clientDetails, setClientDetials] = useState({});
  const role = secureStorage.getItem(SS_ROLE);

  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };

  const statusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "In-Active",
      value: "INACTIVE",
    },
  ];

  const onClickDownLoadReport = () => {
    if (fromDate && !toDate) {
      enqueueSnackbar("Please select To Date", {
        variant: "error",
      });
      return;
    }
    if (
      (fromDate && toDate) ||
      selectedClient?.value ||
      selectedReseller?.value ||
      selectedStatus?.value ||
      van
    ) {
      setLoading(true);
      ApiRequestGet.CustomerListDownload({
        Daterange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        Clienthashid: selectedClient.value ?? "",
        Status: selectedStatus.value ?? "",
        Van: van ? van : "",
        Resellerid: selectedReseller.value ?? "",
        serviceProviderName: selectedServiceProvider,
        role: role,
      })
        .then((res) => {
          saveAs(res, "customer.csv");
          setLoading(false);
          onChange(false);
        })
        .catch((error) => {
          setLoading(false);
        });
          } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error",
      });
    }
  };

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>

      {role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}

      {role?.toUpperCase() !== CLIENT && role?.toUpperCase() !== RESELLER && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Reseller
          </label>

          <CustomSelect
            value={selectedReseller}
            options={resellerList}
            onChange={(data) => setSelectedReseller(data)}
            placeholder={"Select reseller"}
          />
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          VAN
        </label>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="VAN"
          validator=""
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
          value={van}
          onChange={(data) => {
            setVan(data);
          }}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>

        <CustomSelect
          value={selectedStatus}
          options={statusOptions}
          onChange={(data) => setSelectedStatus(data)}
          placeholder={"Status"}
        />
      </div>

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          onClick={onClickDownLoadReport}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default DownloadReportCustomer;
